import React from "react";
import Styles from "./OrderSummery.module.css";

function Tables({ item }) {
  return (
    <>
      <div className={Styles.test_box}>
        <div
          style={{
            width: "250px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            marginTop: "2rem",
            borderBottom: "1px solid black",
          }}
        >
          <p style={{ fontSize: "12px", color: "#fba922" }}>SUBSCRIPTION </p>{" "}
          <p style={{ fontSize: "25px", textTransform: "capitalize"}}> {item.subscription}</p>
        </div>
        <h4 className={Styles.question}>SHIPPING</h4>
        <table>
          <tr>
            <th>School Name</th>
            <th>Kid Name</th>
            <th>Parent Name</th>
            <th>Parent Mobile No</th>
            <th>Parent Email</th>
          </tr>
          <tr>
            <td>{item.shipping.schoolName}</td>
            <td>{item.shipping.kid}</td>
            <td>{item.shipping.parentName}</td>
            <td>{item.shipping.parentMobile}</td>
            <td>{item.shipping.parentEmail}</td>
          </tr>
        </table>
      </div>
      <div className={Styles.test_box}>
        <h4 className={Styles.question}>MENU</h4>
        <table>
          <tr>
            <th>Id</th>
            <th>Day</th>
            <th>Quantity</th>
          </tr>
          {item.menu.map((menu) => {
            return (
              <tr key={menu._id}>
                <td>{menu._id}</td>
                <td>{menu.day}</td>
                <td>{menu.qty}</td>
              </tr>
            );
          })}
        </table>
      </div>
    </>
  );
}

export default Tables;
